module.exports = __webpack_public_path__ + "static/media/ht.a0b173aa.svg";